module.exports = __webpack_public_path__ + "img/logo1.e784a871.png";